import React from "react";
import styled from "styled-components";
import { gradients } from "../theme/gradients";
import { shadows } from "../theme/shadows";

const GlassCard = ({
  children,
  onClick,
  hoverable = false,
  animated = false,
  visible = true,
  delay = 0,
  className,
  ...props
}) => {
  if (animated) {
    return (
      <AnimatedGlassCard
        onClick={onClick}
        hoverable={hoverable || !!onClick}
        visible={visible}
        delay={delay}
        className={className}
        {...props}
      >
        {children}
      </AnimatedGlassCard>
    );
  }

  return (
    <StyledGlassCard
      onClick={onClick}
      hoverable={hoverable || !!onClick}
      className={className}
      {...props}
    >
      {children}
    </StyledGlassCard>
  );
};

const baseCardStyles = `
  background: ${gradients.glass};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 16px 20px;
  box-shadow: ${shadows.md};
  position: relative;
  overflow: hidden;
  will-change: transform;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent
    );
    will-change: opacity;
  }
`;

const StyledGlassCard = styled.div`
  ${baseCardStyles}

  ${({ hoverable }) =>
    hoverable &&
    `
    cursor: pointer;
    transition:
      transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      background 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-2px);
      box-shadow: ${shadows.lg};
      border-color: rgba(255, 255, 255, 0.3);
      background: ${gradients.glassStrong};
    }
  `}
`;

const AnimatedGlassCard = styled.div`
  ${baseCardStyles}

  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) =>
    props.visible ? "translateY(0)" : "translateY(15px)"};
  transition:
    opacity 0.4s ease-out ${(props) => props.delay}ms,
    transform 0.4s ease-out ${(props) => props.delay}ms,
    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;

  ${({ hoverable }) =>
    hoverable &&
    `
    cursor: pointer;

    &:hover {
      transform: ${(props) =>
        props.visible ? "translateY(-2px)" : "translateY(15px)"};
      box-shadow: ${shadows.lg};
      border-color: rgba(255, 255, 255, 0.3);
      background: ${gradients.glassStrong};
    }
  `}
`;

export default GlassCard;
